import {chain, filter, keyBy} from "lodash";
import {getPlayersJsonSuccess, getPlayersSuggestedJsonSuccess} from "modules/actions";
import {PoolTabsType, StatusType} from "modules/enums";
import Api from "modules/utils/Api";
import {call, put} from "typed-redux-saga/macro";

export const fetchPlayersSaga = function* () {
	const result = yield* call(Api.Jsons.players);
	const players = result.data.players || [];

	if (players?.length) {
		const activePlayers = filter(players, {status: StatusType.Active});

		const getIds = (items: typeof players) => chain(items).map("id").value();

		const filterFunctions = {
			[PoolTabsType.Popular]: (items: typeof players) =>
				chain(items)
					.filter((player) => player.isPopular)
					.orderBy((player) => player.numberSelections, "desc")
					.map("id")
					.value(),
			[PoolTabsType.Suggested]: getIds,
			[PoolTabsType.Favorite]: getIds,
			[PoolTabsType.Club]: getIds,
		};

		yield* put(
			getPlayersJsonSuccess({
				players: keyBy(players, "id"),
				poolPlayers: {
					[PoolTabsType.Popular]: filterFunctions[PoolTabsType.Popular](activePlayers),
					[PoolTabsType.Suggested]:
						filterFunctions[PoolTabsType.Suggested](activePlayers),
					[PoolTabsType.Favorite]: filterFunctions[PoolTabsType.Favorite](activePlayers),
					[PoolTabsType.Club]: filterFunctions[PoolTabsType.Club](activePlayers),
				},
			})
		);
	}
};

export const fetchSuggestedPlayersSaga = function* () {
	const suggested = yield* call(Api.Jsons.suggested_players);

	yield* put(getPlayersSuggestedJsonSuccess(suggested.data));
};

export default fetchPlayersSaga;
